import React, { FC } from 'react';
import styles from './footer.module.scss'

interface IProps {
  pageState: {
    pageIndex: number
  },
  canPreviousPage: boolean
  canNextPage: boolean
  page: Array<any>
  gotoPage: (pageIndex) => void
  previousPage: () => void
  loading: boolean
  nextPage: () => void
  pageOptions: Array<any>
  paginationLabel: string
  itemsLength: number
  withSiderBar?: boolean
}

const Footer: FC<IProps> = ({ pageState, loading, canPreviousPage, canNextPage, pageOptions, previousPage, nextPage, gotoPage, page, itemsLength, withSiderBar, paginationLabel }: IProps) => {
  const leftPagination = () => {
    switch (pageState.pageIndex) {
      case 0:
        return [0, pageOptions[pageState.pageIndex + 1] ? pageOptions[pageState.pageIndex + 1] : null, pageOptions[pageState.pageIndex + 2] ? pageOptions[pageState.pageIndex + 2] : null].filter(val => val !== null)
      default:
        return [pageState.pageIndex - 1, pageState.pageIndex, pageOptions[pageState.pageIndex + 1] ? pageOptions[pageState.pageIndex + 1] : null].filter(val => val !== null)
    }
  }




  const rightPagination = [pageOptions[pageState.pageIndex + 3] ? pageOptions[pageState.pageIndex + 3] : null, pageOptions[pageState.pageIndex + 4] ? pageOptions[pageState.pageIndex + 4] : null, pageOptions[pageState.pageIndex + 5] ? pageOptions[pageState.pageIndex + 5] : null].filter(val => val !== null)

  return (
    <footer className={`${styles.footer} ${withSiderBar ? styles.footerSmall : ''}`}>
      {!loading && <>
        <p>Viser <span className='tw-font-medium'>{pageState.pageIndex * 10 ? pageState.pageIndex * 10 : itemsLength > 0 ? 1 : 0}</span> til <span className='tw-font-medium'>{(pageState.pageIndex * 10) + page.length}</span> af <span className='tw-font-medium'>{itemsLength}</span> {paginationLabel}</p>
        {pageOptions.length > 1 && <div className="tw-flex tw-ml-auto">
          <button className={styles.paginationButton} disabled={!canPreviousPage} onClick={previousPage}>
            <svg className='tw-h-5 tw-w-5' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
          </button>
          {leftPagination().map((page, index) => <button key={index} onClick={() => gotoPage(Number(page))} className={`${styles.paginationButton} ${pageState.pageIndex === Number(page) ? 'tw-font-semibold' : ''}`}>{page + 1}</button>)}
          <select value='...' className={styles.paginationButton} onChange={(e) => gotoPage(Number(e.target.value) - 1)}>
            <option value="">...</option>
            {pageOptions.map((pageOption, index) => <option key={index}>{pageOption + 1}</option>)}
          </select>
          {rightPagination.map((page, index) => <button key={index} onClick={() => gotoPage(Number(page))} className={`${styles.paginationButton} ${pageState.pageIndex === Number(page) ? 'tw-font-semibold' : ''}`}>{page + 1}</button>)}
          <button className={styles.paginationButton} disabled={!canNextPage} onClick={nextPage}>
            <svg className='tw-h-5 tw-w-5' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </button>
        </div>}
      </>}
    </footer>
  )
}


export default Footer